module.exports = __webpack_public_path__ + "img/log-in.bb6dbb04.svg";